import React, { useState } from "react";
import { StatCard, MetaCell, Expandable, DataTable, SectionTitle, LastSynced, EmptyState } from "./DashboardPrimitives";

const JiraDashboard = ({ data, formatLastConnected }) => {
  const [openProject, setOpenProject] = useState(null);
  const toggleProject = (id) => setOpenProject(openProject === id ? null : id);

  if (!data?.connector_data) return <EmptyState message="No Jira data available" />;

  const { user, projects, statuses, users } = data.connector_data;

  return (
    <div className="space-y-6">
      {/* Identity strip */}
      <div className="pb-4 border-b border-gray-100">
        <p className="text-sm font-semibold text-gray-800">{user.display_name}</p>
        <p className="text-xs text-gray-400">{user.email}</p>
        <LastSynced value={data?.last_synced_at} formatFn={formatLastConnected} />
      </div>

      {/* Account snapshot */}
      <div>
        <SectionTitle title="Account Snapshot" />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <StatCard label="Account ID" value={user.account_id.slice(0, 8) + "…"} />
          <StatCard label="Projects" value={projects.length} />
          <StatCard label="Users / Apps" value={users.length} />
          <StatCard label="Statuses" value={statuses.length} />
        </div>
      </div>

      {/* Projects */}
      <div className="space-y-3">
        <SectionTitle title="Projects" count={projects.length} />
        {projects.map((project) => (
          <Expandable
            key={project.id}
            title={
              <div className="flex items-center gap-2">
                {project.avatarUrls?.["24x24"] && (
                  <img src={project.avatarUrls["24x24"]} alt="project" className="w-5 h-5 rounded flex-shrink-0" />
                )}
                <span>{project.name}</span>
              </div>
            }
            isOpen={openProject === project.id}
            onToggle={() => toggleProject(project.id)}
            badge={
              <div className="flex gap-1.5">
                <span
                  className="text-xs px-2 py-0.5 rounded-full font-medium text-white"
                  style={{ backgroundColor: "var(--app-primary-color, #26256b)" }}
                >
                  {project.projectTypeKey}
                </span>
                {project.isPrivate && (
                  <span className="text-xs px-2 py-0.5 rounded-full font-medium bg-red-100 text-red-700">Private</span>
                )}
              </div>
            }
          >
            <div className="space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <MetaCell label="Key" value={project.key} />
                <MetaCell label="Category" value={project.projectCategory?.name || "—"} />
                <MetaCell label="Style" value={project.style} />
              </div>
              <DataTable
                title="Statuses"
                headers={["Name", "Category", "Color"]}
                rows={statuses.filter((s) => s.scope?.project?.id === project.id).map((s) => [s.name, s.statusCategory.name, s.statusCategory.colorName])}
              />
              <DataTable
                title="Users & Apps"
                headers={["Name", "Type", "Active"]}
                rows={users.map((u) => [u.displayName, u.accountType, u.active ? "Yes" : "No"])}
              />
            </div>
          </Expandable>
        ))}
      </div>
    </div>
  );
};

export default JiraDashboard;
